<template>
    <v-flex xs12 text-xs-center my-3>
        <p v-if="!services || services.length == 0">No se han encontrado servicios</p>
        <v-chip outline disabled v-for="service in items" :key="service.id" dark color="primary darken-1">
            <v-avatar>
                <v-icon dark size="14">fas fa-star-of-life</v-icon>
            </v-avatar>
            {{service.description}}
        </v-chip>

        <v-chip @click="dialog = true" v-if="hasMore">...y {{hasMore}} más</v-chip>

        <v-dialog scrollable v-model="dialog" max-width="500" >
          <v-card max-height="400">
            <v-card-title>
              Servicios Disponibles
            </v-card-title>
            <v-card-text>
              <v-chip outline disabled v-for="service in services" :key="service.id" dark color="primary darken-1">
                <v-avatar>
                  <v-icon dark size="14">fas fa-star-of-life</v-icon>
                </v-avatar>
                {{service.description}}
              </v-chip>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn round color="primary" @click="dialog=false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>

    import {mapState} from 'vuex'

    export default{
        props: {
          services: {
            type: Array,
            required: true
          },
          visibleItems: {
            type: Number,
            default: 3
          }
        },
        data(){
          return {
            dialog: false
          }
        },
        computed:{
          items(){
            const vm = this
            return vm.services.filter((serv, index) => (index+1) <= vm.visibleItems)
          },
          hasMore(){
            const vm = this
            if(vm.services.length <= vm.visibleItems) return 0
            return vm.services.length - vm.visibleItems
          }
        },
    }
</script>
